// extracted by mini-css-extract-plugin
module.exports = {"questionLink":"_-_-pharmacy-src-user-userActivityItem-userActivityItem__questionLink--1ksmv","action":"_-_-pharmacy-src-user-userActivityItem-userActivityItem__action--j7jwk"};